import React, { Component } from 'react';
import '../styles.css';
import { PLAYER1, PLAYER2, HINT } from '../const.js';
import { playerColor } from '../logic';
import { FAST, SLOW, HIDDEN } from '../../HOME/const';

class Line extends Component {
  render() {
    const { p1, p2, visibility, winner } = this.props;

    if (visibility === HIDDEN) {
      return null;
    }

    const width = p2.x - p1.x;
    const height = p2.y - p1.y;

    const length = Math.sqrt(width * width + height * height);
    const angle = (Math.atan2(height, width) * 180) / Math.PI;

    const margin = `${p1.y}px 0 0 ${p1.x}px`;
    const rotate = `rotate(${angle}deg)`;

    let cls = 'line';
    let duration = 0;

    if (visibility === SLOW || visibility === FAST) {
      cls += ' line-animation';
      duration = visibility;
    } else if (visibility === HINT) {
      cls += ' fadein-animation';
      duration = FAST;
    }

    duration = `${duration}ms`;

    const color = winner
      ? 'transparent'
      : visibility === FAST || visibility === SLOW
      ? 'orange'
      : visibility === PLAYER1 || visibility === PLAYER2
      ? playerColor(visibility)
      : visibility === HINT
      ? 'rgba(0,0,0,0.5)'
      : 'rgba(255,255,255,0.5)';

    const thickness = visibility === HINT ? '2px' : '2px';

    return (
      <div
        style={{
          width: Math.abs(length),
          height: Math.abs(height),
          margin: margin,
          // border: "1px solid black",
          gridArea: '1/1',
        }}
      >
        <div
          className={cls}
          style={{ transform: rotate, background: color, animationDuration: duration, height: thickness }}
        />
      </div>
    );
  }
}

export default Line;
